import { FC } from 'react';

import {
  DEFAULT_OUTBRAIN_WIDGET_ID,
  type OutbrainWidgetId,
  resolveOutbrainWidgetId,
} from '../Outbrain/constants.ts';
import StoryMediumSkeleton from '../StoryMedium/StoryMediumSkeleton.tsx';
import StorySmallSkeleton from '../StorySmallSkeleton/StorySmallSkeleton.tsx';

export interface OutbrainSkeletonProps {
  widgetId?: OutbrainWidgetId;
}

const OutbrainSkeleton: FC<OutbrainSkeletonProps> = ({
  widgetId = DEFAULT_OUTBRAIN_WIDGET_ID,
}) => {
  const resolved = resolveOutbrainWidgetId(widgetId);

  if (resolved === 'JS_13') {
    return (
      <div className="outbrain-skeleton">
        <StoryMediumSkeleton />
      </div>
    );
  }

  return (
    <div className="outbrain-skeleton">
      <StorySmallSkeleton />
      <StorySmallSkeleton />
      <StorySmallSkeleton />
      <StorySmallSkeleton />
    </div>
  );
};

export default OutbrainSkeleton;